import script from "./depth-filter.vue?vue&type=script&setup=true&lang=js"
export * from "./depth-filter.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__